import styled, {css} from "styled-components";

interface OptionsProps {
  selected?: boolean;
}

interface OptionsHeaderProps extends OptionsProps {
  color: string;
}

interface OptionsImageProps {
  rounded?: boolean;
  shadow?: boolean;
  width?: string;
  height?: string;
  objectFit?: "cover" | "contain" | "fill" | "none" | "scale-down";
}
interface OptionsImageContainerProps {
  borderColor?: string;
}

interface OptionsTextProps {
  isBold?: boolean;
  fontSize?: number;
  color?: string;
}

export const SectionGrid = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;

  grid-template-columns: 1fr;

  @media (min-width: 850px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const SectionContainer = styled.div`
  margin-bottom: 48px;
`;

export const SectionTitle = styled.h2`
  font-size: 14px;
  margin-bottom: 14px;
  color: #595959;
`;

interface OptionsBodyProps extends OptionsProps {}

export const OptionsHeader = styled.div<OptionsHeaderProps>`
  /* height: 60px; */
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px 0px 1.9rem;
  overflow: hidden;
  gap: 10px;
  width: 100%;
  color: #595959;

  ${({color}) =>
    color &&
    css`
      background-color: ${color};

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("/images/dusty-bg.png") repeat;
        opacity: 0.03;
        z-index: -1;
      }
    `}
`;
export const OptionsBody = styled.div<OptionsBodyProps>`
  padding: 1.6rem;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  /* height: 105px;
  background: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  z-index: 20;
  padding: 10px 5px;
  position: relative;
  display: flex;
  justify-contents: center;
  align-items: center;
  flex-direction: column;

  @media (min-width: 1200px) and (max-width: 1250px) {
    height: 110px;
    padding: 20px 10px;
  }
  @media (min-width: 1100px) and (max-width: 1249px) {
    height: 130px;
    padding: 20px 10px;
  }

  @media (max-width: 992px) {
    padding: 10px 10px;
  } */
`;

export const OptionsImage = styled.img<OptionsImageProps>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "auto"};
  display: block;
  object-fit: ${(props) => props.objectFit || "cover"};
  border-radius: ${(props) => (props.rounded ? "15px" : "0")};
  box-shadow: ${(props) => (props.shadow ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none")};
  position: relative;
  z-index: 10;
`;

export const OptionsImageContainer = styled.div<OptionsImageContainerProps>`
  border: ${(props) =>
    props.borderColor ? `1px solid ${props.borderColor}` : "1px solid black"};

  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  width: 85px;
  min-width: 85px;
  max-width: 85px;

  height: 60px;
  transform: rotate(-30deg);
  position: relative;
  right: 1px;
  overflow: hidden;
  top: 0px;
  z-index: 5;
`;

export const TagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0 6px;
  border: 2px solid #ffbb96;
  color: #fa541c;
  background: #fff2e8;
  border-radius: 2px;
  min-height: 20px;
  box-sizing: border-box;
`;

export const OptionsText = styled.p<OptionsTextProps>`
  font-weight: ${(props) => (props.isBold ? "600" : "400")};
  font-size: ${(props) => props.fontSize || "14px"};
  width: 100%;
  color: ${(props) => (props.color ? props.color : "#1C1726")};

  @media (max-width: 1100px) {
    font-size: ${(props) => props.fontSize || "12px"};
  }

  @media (max-width: 992px) {
    font-size: ${(props) => props.fontSize || "12px"};
  }

  @media (max-width: 768px) {
    font-size: ${(props) => props.fontSize || "11px"};
  }

  @media (max-width: 576px) {
    font-size: ${(props) => props.fontSize || "10px"};
  }

  @media (max-width: 400px) {
    font-size: ${(props) => props.fontSize || "9px"};
  }
`;
export const OptionsSmallText = styled.span<OptionsTextProps>`
  font-family: Inter;
  font-weight: ${(props) => (props.isBold ? "600" : "400")};
  font-size: ${(props) => props.fontSize || "15px"};
  text-align: left;
  color: ${(props) => (props.color ? props.color : "#1C1726")};
  @media (max-width: 1100px) {
    font-size: ${(props) => props.fontSize || "12px"};
  }
  @media (max-width: 992px) {
    font-size: ${(props) => props.fontSize || "12px"};
  }
  @media (max-width: 768px) {
    font-size: ${(props) => props.fontSize || "11px"};
  }
  @media (max-width: 576px) {
    font-size: ${(props) => props.fontSize || "10px"};
  }
  @media (max-width: 400px) {
    font-size: ${(props) => props.fontSize || "9px"};
  }
`;
export const OptionsTagText = styled.small<OptionsTextProps>`
  font-weight: ${(props) => (props.isBold ? "500" : "400")};
  font-size: 12px;
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
  color: #fa541c;
`;

export const OptionsHeaderGroup = styled.div`
  display: inline-flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    display: inline-flex;
    gap: 10px;
  }
  @media (max-width: 1005px) {
    gap: 5px;
  }
`;

export const Options = styled.div<OptionsProps>`
  height: 100%;
  width: 100%;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  z-index: 9;
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.selected &&
    css`
      border: 1px solid #1c1726;
      & > ${OptionsBody} {
        background-color: #eae6f3;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    `}

  &:hover {
    border: 1px solid #1c1726;

    & > ${OptionsBody} {
      background-color: #eae6f3;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    }
  }
`;
